module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/cetacean-olympics-controversy/"},"excerpt":"The whale team is protesting the presence of the Japanese judges at the recent Cetacean Olympics after one of the Japanese judges attempted…","timeToRead":1,"frontmatter":{"title":"Cetacean Olympics Controversy","tags":["acrobatics","cetaceans","olympics","whales"]}}}]}},"pathContext":{"tag":"cetaceans"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-cetaceans.json
// module id = 756
// module chunks = 229137833126409